<template>
    <div :class="!isMobile?'moncompte':'mmoncompte'">
        <main>
            <div class="left">
                <p v-for="(item, index) in routerlist" :key="index">
                    <router-link
                            :replace="true"
                            :class="['routeBtn',item.path==$route.path || routeTest === index || $route.path=='/Moncompte/Articles'&&index==5 ?'border':'']"
                            :to="item.path" @click.native="onMenuItemClick(item)"
                    >{{item.name[0]}}
                    </router-link>
                </p>
            </div>
            <div class="right">
                <!-- <p class="title">{{$route.name}}</p> -->
                <router-view></router-view>
            </div>
        </main>
    </div>
</template>
<script>
    export default {
        name: "Moncompte",
        data() {
            return {
                isMobile: this.$store.state.isMobile,
                routerlist: [
                    {
                        name: [this.$store.state['langPage']['mobile-compte']['TXT_title_1']],
                        path: "/Moncompte/Informations"
                    },
                    {
                        name: [this.$store.state['langPage']['v4-entreprise']['TXT_monentreprise']],
                        path: "/Moncompte/Entreprise"
                    },
                    {
                        name: [this.$store.state['langPage']['v4-lastthing']['TXT_mesadresses']],
                        path: "/Moncompte/Adresses"
                    },
                    {
                        name: [this.$store.state['langPage']['compte-menu']['TXT_mestransporteurs']],
                        path: "/Moncompte/Transporteurs"
                    },
                    // {
                    //   name: "Mes moyens de paiement",
                    //   path: "/Moncompte/Moyens"
                    // },
                    {
                        name: [this.$store.state['langPage']['compte-menu']['TXT_mescommandes'],this.$store.state['langPage']['v4-lastthing']['TXT_monarticles']],
                        path: "/Commandes"
                    },
                    {
                        name: [this.$store.state['langPage']['catalogue-filtres']['TXT_promotions']],
                        path: "/promotions"
                    },
                    {
                        name: [this.$t("account.word1")],
                        path: "/"
                    }
                ]
            };
        },
        computed: {
            routeTest() {
                let state = null
                this.routerlist.forEach((item, index) => {
                    item.name.forEach((data) => {
                        if (data == this.$route.name) state = index
                        else state = null
                    })
                })
                return state
            }
        },
        methods: {
            async onMenuItemClick(item) {
                if (item.name[0] === this.$t("account.word1")) {
                    localStorage.clear();
                    this.$store.commit('set', {key: 'token', value: ''});
                    window.document.cookie = '';
                    this.$router.push({path: '/'})
                }
            }
        }
    };
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Moncompte.less">
</style>
<style lang="less">
    .moncompte {
        .SubTitle {
            font-size: 0.28rem;
            font-family: Ogg-Roman;
            line-height: 0.48rem;
            padding-bottom: 0.21rem;
        }
    }

    .mmoncompte {
        .SubTitle {
            font-size: 14pt;
            font-family: Ogg-Roman;
        }
    }
</style>
